import React from "react";

const StatusReportIcon = () => {
  return (
    <svg
      width="102"
      height="102"
      viewBox="0 0 102 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_317_1392)">
        <rect
          x="8"
          y="4"
          width="86"
          height="86"
          rx="16"
          fill="#91A5DD"
          shape-rendering="crispEdges"
        />
        <g clip-path="url(#clip0_317_1392)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M46.9069 18.9777H46.7624C41.7392 18.9776 37.7744 18.9776 34.6745 19.3751C31.4972 19.7826 28.927 20.6387 26.8925 22.58C24.8432 24.5327 23.9271 27.0211 23.4935 30.095C23.074 33.0691 23.074 36.8653 23.0741 41.6389V41.639L23.0741 41.7955V52.2045L23.0741 52.361V52.3611C23.074 57.1347 23.074 60.9309 23.4935 63.905C23.9271 66.9786 24.843 69.4668 26.8918 71.4194C28.9264 73.361 31.4968 74.2173 34.6745 74.6248C37.7744 75.0224 41.7393 75.0224 46.7625 75.0223H46.9069H52.3651H52.5096C57.5328 75.0224 61.4977 75.0224 64.5976 74.6248C67.7752 74.2173 70.3456 73.361 72.3803 71.4194C75.6493 68.3044 76.077 63.7596 76.1732 57.4394C76.19 56.3349 75.3083 55.426 74.2039 55.4091C73.0994 55.3923 72.1905 56.274 72.1736 57.3785C72.0734 63.9644 71.5023 66.7315 69.6201 68.5243L69.6187 68.5256C68.4575 69.6338 66.8565 70.3024 64.0888 70.6573C61.273 71.0184 57.5649 71.0223 52.3651 71.0223H46.9069C41.7072 71.0223 37.9991 71.0184 35.1833 70.6573C32.4156 70.3024 30.8146 69.6338 29.6534 68.5256L29.6522 68.5245C28.5034 67.43 27.8203 65.9411 27.4543 63.3463C27.0788 60.6839 27.0741 57.1702 27.0741 52.2045V41.7955C27.0741 36.8298 27.0788 33.3161 27.4543 30.6537C27.8203 28.0589 28.5034 26.57 29.6522 25.4755L29.6534 25.4743C30.8146 24.3662 32.4156 23.6976 35.1833 23.3426C37.9991 22.9815 41.7072 22.9777 46.9069 22.9777H52.3651C57.5649 22.9777 61.273 22.9815 64.0888 23.3426C66.8565 23.6976 68.4575 24.3662 69.6187 25.4743C70.4178 26.2369 71.6838 26.2073 72.4463 25.4083C73.2089 24.6092 73.1793 23.3432 72.3803 22.5806C70.3456 20.6389 67.7752 19.7827 64.5976 19.3751C61.4977 18.9776 57.5329 18.9776 52.5097 18.9777H52.3651H46.9069ZM35.6085 37.1933C34.5039 37.1933 33.6085 38.0887 33.6085 39.1933C33.6085 40.2979 34.5039 41.1933 35.6085 41.1933H44.4781H53.3477C54.4523 41.1933 55.3477 40.2979 55.3477 39.1933C55.3477 38.0887 54.4523 37.1933 53.3477 37.1933H44.4781H35.6085ZM35.6085 47.6022C34.5039 47.6022 33.6085 48.4977 33.6085 49.6022C33.6085 50.7068 34.5039 51.6022 35.6085 51.6022H42.4313C43.5358 51.6022 44.4313 50.7068 44.4313 49.6022C44.4313 48.4977 43.5358 47.6022 42.4313 47.6022H35.6085ZM35.6085 58.0112C34.5039 58.0112 33.6085 58.9066 33.6085 60.0112C33.6085 61.1157 34.5039 62.0112 35.6085 62.0112H39.7022C40.8067 62.0112 41.7022 61.1157 41.7022 60.0112C41.7022 58.9066 40.8067 58.0112 39.7022 58.0112H35.6085ZM71.5596 35.9894C72.4822 35.9892 73.349 36.3394 73.9738 36.935C74.5953 37.5274 74.9258 38.3102 74.9259 39.1051C74.9261 39.9 74.5959 40.6829 73.9746 41.2756L73.9733 41.2768L73.4439 41.7827C73.3312 41.7524 73.209 41.7162 73.0791 41.6733C72.3244 41.4236 71.3376 40.9532 70.4119 40.0705C69.4891 39.1905 69.0081 38.265 68.7567 37.5747C68.7314 37.505 68.7084 37.4379 68.6876 37.3736L69.1458 36.9358L69.1466 36.935C69.7711 36.3397 70.6374 35.9895 71.5596 35.9894ZM61.0853 53.5682L70.2621 44.818C69.423 44.3892 68.5198 43.7932 67.6515 42.9654C66.7274 42.0842 66.0738 41.1607 65.6124 40.3076L56.256 49.229L56.251 49.2337C55.4338 50.0076 55.1435 50.2922 54.9025 50.5865C54.5953 50.964 54.335 51.3659 54.1211 51.7935L54.1202 51.7953C53.9538 52.1272 53.8252 52.4862 53.4561 53.5419L52.3889 56.5947L53.1582 57.3282L56.5079 56.2636C57.6105 55.9131 58.0019 55.786 58.3638 55.6211L58.3655 55.6203C58.8261 55.4109 59.2555 55.1576 59.6554 54.8616C59.9681 54.6288 60.2617 54.3535 61.0853 53.5682ZM66.3837 34.0426L65.1217 35.2485L65.1201 35.25L53.5007 46.3293L53.4983 46.3315C52.7356 47.0538 52.24 47.5238 51.8049 48.0558L51.8023 48.059C51.3133 48.6593 50.8919 49.3079 50.544 50.0035C50.2508 50.5885 50.0369 51.2008 49.7286 52.0835L49.6802 52.2219L48.1874 56.4921L48.1859 56.4965L47.8236 57.5406L47.8233 57.5414C47.6117 58.1498 47.581 58.8059 47.7365 59.4323C47.8919 60.0584 48.224 60.6186 48.6822 61.0555C49.1396 61.4916 49.7053 61.789 50.3116 61.9258C50.9177 62.0626 51.5512 62.0363 52.1445 61.8485L52.1481 61.8473L53.2411 61.4991L53.2424 61.4986L57.7195 60.0757L57.8583 60.0316C58.79 59.7356 59.4195 59.5357 60.0211 59.2616C60.7388 58.9353 61.4116 58.5384 62.0373 58.0751L62.0406 58.0727C62.5741 57.6759 63.0505 57.2215 63.7607 56.5442L63.7608 56.5441L63.8456 56.4632L75.4716 45.3777L75.4732 45.3762L76.7355 44.17C78.1263 42.8433 78.9263 41.0233 78.9259 39.1044C78.9256 37.1855 78.1249 35.3657 76.7336 34.0395C75.3455 32.7165 73.4825 31.9891 71.5589 31.9894C69.6353 31.9897 67.7726 32.7178 66.385 34.0413L66.3837 34.0426Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_317_1392"
          x="0"
          y="0"
          width="102"
          height="102"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_317_1392"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_317_1392"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_317_1392">
          <rect
            width="56"
            height="56"
            fill="white"
            transform="translate(23 19)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default StatusReportIcon;
